var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getActiveDashboard } from './theme';
import { isCssColorString } from '../utils/color';
var SEMANTIC = new Set(['primary', 'success', 'warning', 'danger', 'secondary']);
/** Resolve semantic color names against the active dashboard palette. */
export function resolveSemanticColor(color, fallback) {
    if (!color)
        return fallback !== null && fallback !== void 0 ? fallback : getActiveDashboard().primary;
    if (isCssColorString(color))
        return color;
    if (!SEMANTIC.has(color))
        return color;
    var d = getActiveDashboard();
    switch (color) {
        case 'success':
            return d.success;
        case 'warning':
            return d.warning;
        case 'danger':
            return d.danger;
        case 'secondary':
            return d.secondary;
        case 'primary':
        default:
            return d.primary;
    }
}
/**
 * Pick a color for `value` from ordered stops.
 * Falls back to `fallback` (or theme primary) when stops are empty.
 */
export function resolveValueColor(value, stops, fallback) {
    var e_1, _a;
    var fb = fallback !== null && fallback !== void 0 ? fallback : getActiveDashboard().primary;
    if (!(stops === null || stops === void 0 ? void 0 : stops.length))
        return fb;
    try {
        for (var stops_1 = __values(stops), stops_1_1 = stops_1.next(); !stops_1_1.done; stops_1_1 = stops_1.next()) {
            var stop_1 = stops_1_1.value;
            if (stop_1.upTo === undefined || value <= stop_1.upTo) {
                return resolveSemanticColor(stop_1.color, fb);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (stops_1_1 && !stops_1_1.done && (_a = stops_1.return)) _a.call(stops_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var last = stops[stops.length - 1];
    return resolveSemanticColor(last.color, fb);
}
/** Normalize dial zone inputs to 0–1 fractions with resolved colors. */
export function normalizeDialZones(zones, max) {
    if (!(zones === null || zones === void 0 ? void 0 : zones.length))
        return [];
    var m = Math.max(max, 1);
    return zones.map(function (z) {
        var from = z.from > 1 ? z.from / m : z.from;
        var to = z.to > 1 ? z.to / m : z.to;
        return {
            from: Math.min(1, Math.max(0, from)),
            to: Math.min(1, Math.max(0, to)),
            color: resolveSemanticColor(z.color),
        };
    });
}
/** Read colorStops from widget props (supports alias `thresholds`). */
export function readColorStops(props) {
    var _a;
    var raw = (_a = props.colorStops) !== null && _a !== void 0 ? _a : props.thresholds;
    if (!Array.isArray(raw) || raw.length === 0)
        return undefined;
    return raw
        .map(function (s) {
        if (!s || typeof s !== 'object')
            return null;
        var o = s;
        var color = typeof o.color === 'string' ? o.color : '';
        if (!color)
            return null;
        var stop = { color: color };
        if (typeof o.upTo === 'number')
            stop.upTo = o.upTo;
        else if (typeof o.max === 'number')
            stop.upTo = o.max;
        return stop;
    })
        .filter(function (s) { return s !== null; });
}
export function readDialZones(props) {
    var _a;
    var raw = (_a = props.colorZones) !== null && _a !== void 0 ? _a : props.zones;
    if (!Array.isArray(raw) || raw.length === 0)
        return undefined;
    return raw
        .map(function (z) {
        if (!z || typeof z !== 'object')
            return null;
        var o = z;
        if (typeof o.from !== 'number' || typeof o.to !== 'number' || typeof o.color !== 'string') {
            return null;
        }
        return { from: o.from, to: o.to, color: o.color };
    })
        .filter(function (z) { return z !== null; });
}
